export default __webpack_public_path__ + "static/media/checkmark.2fca5711.svg";